module.exports = __webpack_public_path__ + "static/media/ic-video.c207aff4.svg";